/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {applyPolyfills, defineCustomElements} from '@littlerobotfriends/sotsc-game/loader'
import {Block} from 'baseui/block'
import {useSelector} from 'react-redux'
import React, {useEffect} from 'react'
import {useHistory} from 'react-router'
import {routes} from '../../utils/config'

const Play = () => {
  const history = useHistory()
  const {selectedStudent} = useSelector(state => state.user)

  useEffect(() => {
    if (selectedStudent === null) {
      // no student selected... go back to selector screen
      history.push(routes.roleSelector.url)
    }
  })

  useEffect(() => {
    const quitHandler = event => {
      history.push(routes.roleSelector.url)
    }
    window.addEventListener('sotsc-is-quitting', quitHandler)
    //cleanup this component
    return () => {
      window.removeEventListener('sotsc-is-quitting', quitHandler)
    }
  }, [history])

  return (
    <Block overflow="hidden" width="100%" height="100%">
      {selectedStudent ? <sotsc-game student={selectedStudent} /> : 'no student selected'}
    </Block>
  )
}

applyPolyfills().then(() => {
  defineCustomElements()
})

export default Play
